export type CleaningPickupStatus = "sent" | "already_sent" | "in_progress" | "failed" | "unknown";

export function cleaningPickupFeedback(status?: CleaningPickupStatus): { message: string; isError: boolean } {
  switch (status) {
    case "sent": return { message: "集荷依頼メールを送信しました。", isError: false };
    case "already_sent": return { message: "本日の集荷依頼メールは送信済みです（再送なし）。", isError: false };
    case "in_progress": return { message: "本日の集荷依頼メールは別の操作で送信中です。", isError: false };
    case "failed": return { message: "メールは送信できませんでした。再度クリーニング集荷連絡を押してください。", isError: true };
    default: return { message: "メールの送信結果を確認できません。重複防止のため送信履歴を管理者に確認してください。", isError: true };
  }
}
